import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-page-header',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './pageHeader.component.html',
})
export class PageHeaderComponent {

    @Input() title: string;
    @Input() iconClass: string;
    @Input() iconText: string;

    constructor() {
    }
}
